/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice } from "@reduxjs/toolkit";
import { WebAuthnRegistrationResponse } from "./operations";

export interface WebAuthnDeviceError {
  code?: number;
  message?: string;
}

interface WebAuthnSettingState {
  credentialName: string;
  loading: boolean;
  webAuthnRequesting: boolean;
  registered: boolean;
  webAuthns: WebAuthnRegistrationResponse[];
  webAuthnError: WebAuthnDeviceError | null;
  error: string | null;
  authenticatorType: string | null;
}

const WebAuthnSettingSlice = createSlice({
  name: "webAuthnSetting",
  initialState: {
    credentialName: "",
    loading: true,
    webAuthnRequesting: false,
    registered: false,
    webAuthns: [] as WebAuthnRegistrationResponse[],
    webAuthnError: null as never as WebAuthnDeviceError,
    error: null,
    authenticatorType: null,
  } as WebAuthnSettingState,
  reducers: {
    start(state) {
      state.loading = true;
    },
    success(state) {
      state.loading = false;
    },
    failure(state, { payload }) {
      state.error = payload;
      state.loading = false;
    },
    registerFailed(state, { payload }) {
      state.loading = false;
      state.webAuthnRequesting = false;
      state.webAuthnError = payload;
    },
    clearError(state) {
      state.error = null;
      state.webAuthnError = null;
    },
    updateCredentialName(state, { payload }) {
      state.credentialName = payload;
    },
    startRegisteringCredential(state) {
      state.webAuthnRequesting = true;
    },
    finishRegisteringCredential(state) {
      state.webAuthnRequesting = false;
      state.credentialName = "";
    },
    unregisterDevice(state, { payload }) {
      state.webAuthns = state.webAuthns.filter((d) => d.id !== payload.id);
    },
    setRegisteredDevices(state, { payload }) {
      state.webAuthns = payload;
    },
  },
});

export const WebAuthnSettingActions = WebAuthnSettingSlice.actions;

export default WebAuthnSettingSlice.reducer;
